import React, { useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./CalendarSidebar.css";
import { addMonths, subMonths } from "date-fns";
import { useNavigate } from "react-router-dom"; // ✅ added

export default function CalendarSidebar() {
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [calendarViewDate, setCalendarViewDate] = useState(new Date());

    const navigate = useNavigate(); // ✅ added

    const currentMonthLabel = calendarViewDate.toLocaleDateString("en-US", {
        month: "long",
        year: "numeric",
    });

    const goToPrevMonth = () => {
        setCalendarViewDate(subMonths(calendarViewDate, 1));
    };

    const goToNextMonth = () => {
        setCalendarViewDate(addMonths(calendarViewDate, 1));
    };

    return (
        <div className="calendar-sidebar">
            <div className="calendar-header">
                <button onClick={goToPrevMonth}>&lt;</button>
                <h2>{currentMonthLabel}</h2>
                <button onClick={goToNextMonth}>&gt;</button>
            </div>

            <div className="calendar-wrapper">
                <Calendar
                    onChange={(date) => {
                        setSelectedDate(date);
                        navigate("/scheduler", {
                            state: { selectedDate: date.toISOString() }, // ✅ pass selected date
                        });
                    }}
                    value={selectedDate}
                    activeStartDate={calendarViewDate}
                    tileClassName={({ date }) =>
                        date.toDateString() === new Date().toDateString() ? "today-tile" : null
                    }
                    nextLabel={null}
                    prevLabel={null}
                    next2Label={null}
                    prev2Label={null}
                    showNavigation={false}
                />
            </div>

            <div className="agenda-view">
                <h3>Events for {selectedDate.toDateString()}</h3>
                <ul>
                    <li><span className="color-bar purple" /> Sample Event 1 (All Day)</li>
                    <li><span className="color-bar blue" /> Sample Event 2 (3–5 PM)</li>
                </ul>
            </div>
        </div>
    );
}
